export const USER_DISPLAY_NAME = 'User_DISPLAYNAME';

export const ACCOUNT_DISPLAY_NAME = 'Account_DISPLAYNAME';

export const ROLE_DISPLAY_NAME = 'Role_DISPLAYNAME';

export const ENTITLEMENT_DISPLAY_NAME = 'Ent_DISPLAYNAME';

export const CHILD_ENTITLEMENT_DISPLAY_NAME = 'Ent2_DISPLAYNAME';

export const EO_ACCOUNT_DISPLAY_NAME = 'DEFAULTACCOUNTNAME';
export const EO_ENTITLEMENT_DISPLAY_NAME = 'DEFAULTENTITLEMENTNAME';
export const EO_CHILD_ENTITLEMENT_DISPLAY_NAME = 'DEFAULTENTITLEMENT2NAME';

export const USER = 'User';
export const ROLE = 'Role';
export const ACCOUNT = 'Account';
export const ENTITLEMENT = 'Entitlement';
export const CHILD_ENTITLEMENT = 'Child Entitlement';
